import { Reviews } from 'src/pages/Reviews';
import { ReviewsPageRedesign } from 'src/pages/ReviewsPageRedesign';
import { TrackedSectionsProvider } from 'src/hooks/useTrackedSections';
import { useShowReviewsPageRedesign } from 'src/hooks/useShowReviewsPageRedesign';
import { AssetPreloader } from '../ReviewsPageRedesign/components';

export const ReviewsPage = () => {
  const { shouldShowReviewsPageRedesign } = useShowReviewsPageRedesign();

  return (
    <TrackedSectionsProvider>
      {shouldShowReviewsPageRedesign ? (
        <>
          <AssetPreloader />
          <ReviewsPageRedesign />
        </>
      ) : (
        <Reviews />
      )}
    </TrackedSectionsProvider>
  );
};
